
import Typography from '@mui/material/Typography';


export const TextDrugDesipramine = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Desipramine is used to treat depression. Desipramine is in a class of medications called tricyclic antidepressants. 
It works by increasing the amounts of certain natural substances in the brain that are needed for mental balance.

.<br /><br />



Sources: <br /><br />
https://medlineplus.gov/druginfo/meds/a682387.html 

</Typography>

</div>

)
}